import { type PropsWithChildren } from 'react'
import type { DataViewStatus } from '@vtex/admin-ui'
import { csx, Skeleton } from '@vtex/admin-ui'

import * as style from './products-listing.styles'

export function PlainCell(props: PropsWithChildren<PlainCellProps>) {
  const { children, context, ...restProps } = props

  if (context === 'loading') return <PlainCellSkeleton />

  return (
    <div className={csx(style.cellContainer)} {...restProps}>
      {children}
    </div>
  )
}

function PlainCellSkeleton() {
  return (
    <div className={csx(style.cellContainer)}>
      <Skeleton className={csx({ height: '1.5rem' })} />
    </div>
  )
}

interface PlainCellProps {
  context: DataViewStatus
}
